<template>
  <div style="display: flex; flex-direction: column">
    <template v-if="typeVirtualHbl === VirtualBillType.NORMAL_VIRTUAL_BILL_TYPE.code">
      <cargo-ag-grid
        key="normal"
        :grid-options="bill.gridOptions"
        :column-defs="bill.columnDefs"
        :row-data="billFinalRowData"
        style="width: 100%; height: 200px"
      />
      <!-- <div style="padding: 5px 0">
        <div style="float: right">
          <el-button :disabled="true" type="primary">{{ $t("SeaExport.Add") }}</el-button>
          <el-button :disabled="true" type="danger">{{ $t("SeaExport.Delete") }}</el-button>
        </div>
      </div> -->
    </template>
    <template v-if="typeVirtualHbl === VirtualBillType.MERGE_VIRTUAL_BILL_TYPE.code">
      <cargo-ag-grid
        key="merge"
        config-module="2023121501"
        :grid-options="virtualMergeBill.gridOptions"
        :column-defs="virtualMergeBill.columnDefs"
        :row-data="virtualMergeBillFinalRowData"
        style="width: 100%; height: 200px"
      />
      <!-- <div style="padding: 5px 0">
        <div style="float: right">
          <el-button :disabled="true" type="primary">{{ $t("SeaExport.Join") }}</el-button>
          <el-button :disabled="true" type="danger">{{ $t("SeaExport.Delete") }}</el-button>
        </div>
      </div> -->
    </template>
  </div>
</template>

<script>
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as VirtualBillType from '@/class/cargo/model/parameters/VirtualBillType'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'

export default {
  name: 'SeSubBillOrderBusinessAssociation',
  props: {
    job: { type: Object, default: () => { } },
    cargoDocList: { type: Array, default: () => [] },
    typeVirtualHbl: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      VirtualBillType,
      bill: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor
          },
          context: {
            componentParent: this
          },
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BlSplitList'),
            colId: 'hblNbr2',
            field: 'hblNbr2',
            width: 294
          }, {
            headerName: this.$t('SeaExport.NumberOfPackagesOnBl'),
            colId: 'quantity',
            field: 'quantity',
            width: 100,
            hide: true,
            valueFormatter: (params) => {
              return (!params.value || isNaN(params.value) || Number(params.value) === 0) ? '' : params.value
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_InsideQuantity'),
            colId: 'insideQuantity',
            field: 'insideQuantity',
            width: 100,
            hide: true,
            valueFormatter: (params) => {
              return (!params.value || isNaN(params.value) || Number(params.value) === 0) ? '' : params.value
            }
          }, {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weight',
            field: 'weight',
            width: 100,
            hide: true
          }, {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubage',
            field: 'cubage',
            width: 100,
            hide: true
          }, {
            headerName: this.$t('SeaExport.HBLRefNo2'),
            colId: 'hblRefNo',
            field: 'hblRefNo',
            width: 200,
            hide: false,
            initialWidth: 180,
            editable: () => !this.disabled,
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => ({
              selectProps: {
                tagValue: 'code',
                tagName: 'code',
                staticOptions: this.hblNoList,
                filterable: true
              }
            }),
            initialHide: false,
            valueFormatter: (params) => {
              return params.value
            }
          }
        ]
      },
      // 形式分单并单
      virtualMergeBill: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 109
          },
          {
            headerName: this.$t('SeaExport.Mbl2'),
            colId: 'mbl',
            field: 'mbl',
            width: 109
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantityActual',
            field: 'quantityActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weightActual',
            field: 'weightActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubageActual',
            field: 'cubageActual',
            width: 85
          },
          {
            headerName: 'SO No.',
            colId: 'soNo',
            field: 'soNo',
            width: 85
          }
        ],
        rowData: []
      }
    }
  },
  computed: {
    hblNoList() {
      const hblNoList = []
      if ([BillType.SPLIT_BILL_TYPE.code, BillType.MERGE_BILL_TYPE.code].includes(this.job.typeHBL)) {
        for (const item of this.cargoDocList) {
          if (item.docType === CargoDocConsts.HBL2 && item.hblNbr2) {
            hblNoList.push({ code: item.hblNbr2 })
          }
        }
      } else {
        for (const item of this.cargoDocList) {
          if (item.docType === CargoDocConsts.HBL && item.hblNbr2) {
            hblNoList.push({ code: item.hblNbr2 })
          }
        }
      }
      return hblNoList
    },
    billFinalRowData() {
      const subBillCargoDocs = []
      if (this.cargoDocList && this.cargoDocList.length > 0) {
        for (const cd of this.cargoDocList) {
          if (cd.docType === CargoDocConsts.HAWB2) {
            subBillCargoDocs.push(cd)
          }
        }
      }
      return subBillCargoDocs.filter(p => !p.deleted).sort((a, b) => {
        const suffixA = a.hblNbr2.replace(`${this.job.jobNo}`, '')
        const suffixB = b.hblNbr2.replace(`${this.job.jobNo}`, '')
        return suffixA - suffixB
      })
    },
    virtualMergeBillFinalRowData() {
      return (this.virtualMergeBill.rowData) ? this.virtualMergeBill.rowData.filter(p => !p.deleted) : []
    }
  },
  async created() {
    const jointSlavesHAWB2 = await new SeaExportJob(this.job).getJointSlavesHAWB2()
    this.virtualMergeBill.rowData = jointSlavesHAWB2
  }
}
</script>
